import { RibbonBar, RibbonDivider, RibbonSection, RibbonButton } from 'common/components';
import { Spin } from 'antd';
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import GridViewSelector from 'common/components/grid-view/controllers/selectors';
import { DeleteOutlined, FolderOpenOutlined, EditOutlined, PlusOutlined, UploadOutlined, DownloadOutlined, LoadingOutlined } from '@ant-design/icons';
import { forwardTo } from 'utils/common/route';
import { Can } from 'context/Can';
import { ABILITY_ACTION, ABILITY_SUBJECT } from 'static/Permission';
import {
  ManageSharingSection,
  ViewLayout
} from 'pages/home/ribbon/components';
import { dialogFunction, CustomNotification } from 'common/components';
import * as api from 'config/axios';
import { CustomNotification } from 'common/components';
import * as endpoints from 'services/gr-eval-form/endpoints';
import { useDispatchReloadPage } from 'hooks/useReloadPage';
import BulkUploadGRDataModal from './BulkUploadGRDataModal';
import FilterGREvalFormList from './components/FilterGREvalFormList';
import { WithLoading } from 'common/components';
const GREvalFormListRibbon = () => {
  const reloadPage = useDispatchReloadPage();
  const selectedEvalFormDetail = useSelector(
    GridViewSelector.makeSelectDetailCurrentITemsSelection()
  );

  // const productItemId =
  //   selectedEvalFormDetail && selectedEvalFormDetail.length > 0
  //     ? selectedEvalFormDetail[0].productItemId
  //     : undefined;

  const selectedItems = selectedEvalFormDetail ?? [];
  const oneSelected = selectedItems.length === 1;
  const firstItem = oneSelected ? selectedItems[0] : null;
  const isCompleted =
    firstItem?.status &&
    firstItem.status.toString().toLowerCase() === 'completed';
  const disableEdit = !oneSelected || isCompleted;
  const [visibleImportModal, setVisibleImportModal] = useState(false);
  const [isExportLoading, setIsExportLoading] = useState(false);
  const onClickImportButton = () => {
    setVisibleImportModal(true);
  };
  const handleDeleteModal = () => {
    dialogFunction({
      type: 'warn',
      content: `Are you sure you want to delete selected item?`,
      okText: 'Delete',
      okButtonProps: {
        type: 'danger',
      },
      onOk: handleDelete,
    });
  };

  const handleDelete = async () => {
    try {
      const response = await api.sendPost(
        endpoints.DELETE_GR_EVAL_PROJECT, { id: selectedEvalFormDetail.map(item => item.id) }
      );
      if (response?.isSuccess) {
        CustomNotification.success('Evaluation project deleted successfully');
        reloadPage();
      } else {
        CustomNotification.error(response?.message || 'Failed to delete Evaluation project');
      }
    } catch (error) {
      console.error('Error deleting Evaluation project :', error);
      CustomNotification.error('Error deleting Evaluation project ');
    }
  };
  const sendDownloadRequest = (url) => {
    api
      .sendDownload({
        url,
      })
      .finally(() => {
        setIsExportLoading(false);
      });
  };
  const handleExport = async () => {
    setIsExportLoading(true);
    try {
      const response = await api.sendPost(
        endpoints.EXPORT_GR_EVAL_GRID
      );
      if (response?.isSuccess) {
        CustomNotification.success('Export generated successfully');
        const fileUrl = response.data?.url;
        sendDownloadRequest(fileUrl);
      } else {
        CustomNotification.error(response?.message || 'Failed to export');
        setIsExportLoading(false);
      }
    } catch (error) {
      console.error('Error exporting grid :', error);
      CustomNotification.error('Error exporting grid ');
      setIsExportLoading(false);
    }
  };

  return (
    <RibbonBar>
      <ManageSharingSection />
      <RibbonDivider />
      {/* <Can I={ABILITY_ACTION.CREATE} a={ABILITY_SUBJECT.GR_EVALUATION_FORM}>
        <RibbonSection>
          <RibbonButton
            icon={<PlusOutlined />}
            label="Create"
            onClick={() => forwardTo(`/gr/eval-form`)}
          />
        </RibbonSection>
      </Can> */}

      <Can I={ABILITY_ACTION.EDIT} a={ABILITY_SUBJECT.GR_EVALUATION_FORM}>
        <RibbonSection>
          <RibbonButton
            icon={<EditOutlined />}
            label="Edit"
            onClick={() => forwardTo(`/gr/eval-form/${firstItem?.id}`)}
            disabled={disableEdit}
          />
        </RibbonSection>
      </Can>

      <ViewLayout disabled />

      <Can I={ABILITY_ACTION.DELETE} a={ABILITY_SUBJECT.GR_EVALUATION_FORM}>
        <RibbonSection>
          <RibbonButton
            icon={<DeleteOutlined />}
            label="Delete"
            onClick={handleDeleteModal}
            disabled={selectedItems.length === 0}
          />
        </RibbonSection>
      </Can>
      <RibbonDivider />
      <FilterGREvalFormList/>
      <RibbonSection>
        <RibbonButton
          icon={isExportLoading ? <Spin indicator={<LoadingOutlined spin />} size="large" /> : <DownloadOutlined />}
          label={isExportLoading ? "Exporting.." : "Export"}
          onClick={handleExport}
          disabled={selectedItems.length > 0}
        />
      </RibbonSection>
      <Can I={ABILITY_ACTION.BULK_UPLOAD} a={ABILITY_SUBJECT.GR_EVALUATION_FORM}>
        <RibbonDivider />
        <RibbonSection>
          <RibbonButton
            icon={<UploadOutlined />}
            label="Bulk Upload"
            onClick={onClickImportButton}
          />
          {
            visibleImportModal && (
              <BulkUploadGRDataModal
                visible={visibleImportModal}
                setVisible={setVisibleImportModal}
              />
            )
          }
        </RibbonSection>
      </Can>
    </RibbonBar>
  );
};
export default GREvalFormListRibbon;
